
export enum CustomerTypeOfSvcIndicatorCd {
	LOGISTICS = 'Logistics',
	RESTRICTED = 'Restricted',
	TRAFFIC = 'Traffic'}
